import { useFeature } from '@treams/treams-hooks/useFeature';
import {
	EvaluationSectionItem,
	EvaluationSectionItemType,
	EvaluationSubmission,
	EvaluationSubmissionGoal,
	EvaluationSubmissionItem,
	EvaluationSubmissionParty,
	FeatureName,
} from '@treams/treams-network';

import CompetencyDisplay from './display/CompetencyDisplay';
import MultipleChoiceDisplay from './display/MultipleChoiceDisplay';
import OpenQuestionDisplay from './display/OpenQuestionDisplay';
import ReviewGoalsDisplay from './display/ReviewGoalsDisplay';
import SentimentDisplay from './display/SentimentDisplay';
import StarsDisplay from './display/StarsDisplay';

export default function EvaluationAnswerDisplay({
	resultItem,
	sectionItem,
	party,
	submission,
	sectionIndex,
	itemIndex,
	goal,
}: {
	resultItem: EvaluationSubmissionItem;
	sectionItem: EvaluationSectionItem;
	party: EvaluationSubmissionParty;
	submission: EvaluationSubmission;
	sectionIndex: number;
	itemIndex: number;
	goal?: EvaluationSubmissionGoal;
}) {
	const multipleChoiceEnabled = useFeature(FeatureName.ConversationMultipleChoice);

	if (resultItem.type === EvaluationSectionItemType.MultipleChoice) {
		if (!multipleChoiceEnabled || !sectionItem.multipleChoice) {
			return null;
		}

		return (
			<MultipleChoiceDisplay
				item={sectionItem.multipleChoice}
				indices={resultItem.multipleChoice}
			/>
		);
	}

	if (resultItem.type === EvaluationSectionItemType.Competency) {
		return (
			<CompetencyDisplay
				party={party}
				submission={submission}
				section={sectionIndex}
				item={itemIndex}
			/>
		);
	}

	if (resultItem.type === EvaluationSectionItemType.OpenQuestion) {
		return <OpenQuestionDisplay item={resultItem} />;
	}

	if (resultItem.type === EvaluationSectionItemType.Sentiment) {
		return <SentimentDisplay item={resultItem} />;
	}

	if (resultItem.type === EvaluationSectionItemType.Stars) {
		return <StarsDisplay item={resultItem} />;
	}

	if (resultItem.type === EvaluationSectionItemType.ReviewGoals) {
		return <ReviewGoalsDisplay form={sectionItem} item={resultItem} goal={goal!} />;
	}

	return <p>Unknown item type</p>;
}
